import { render, staticRenderFns } from "./PasswordSettingPage.vue?vue&type=template&id=64b086b2&scoped=true"
import script from "./PasswordSettingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordSettingPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PasswordSettingPage.vue?vue&type=style&index=0&id=64b086b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b086b2",
  null
  
)

export default component.exports